import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Link, Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { config } from '../../../../constants';
import { CONSTANTS } from '../../../../constants/constants';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main
  }
}));

const CardButton = ({ document, handleDeleteFlow, handleCancelFlow }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { status, flowId } = document;
  const PATH_VIEW_DOCUMENT = `${config.FIRMA_FRONT_URL}/validate/${flowId}`;

  return (
    <>
      {status === CONSTANTS.DOCUMENT.STATUS.INIT &&
        <Grid item>
          <Link
            component={RouterLink}
            to={`/file/flow/${document.id}`}
            style={{ textDecoration: 'none', textTransform: 'uppercase' }}
          >
            <Button variant='contained' color='primary'>
              {t('documentMenu:createFlow')}
            </Button>
          </Link>
        </Grid>
      }
      {(status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN || status === CONSTANTS.DOCUMENT.STATUS.SIGNED) && (
        <Grid item>
          <Link
            component={RouterLink}
            to={{ pathname: PATH_VIEW_DOCUMENT }}
            style={{ textDecoration: 'none', textTransform: 'uppercase' }}
            target='_blank'
          >
            <Button variant='contained' color='primary'>
              {t('fileMenu:viewTransaction')}
            </Button>
          </Link>
        </Grid>)
      }
      {(status === CONSTANTS.DOCUMENT.STATUS.ERROR || status === CONSTANTS.DOCUMENT.STATUS.REJECTED || status === CONSTANTS.DOCUMENT.STATUS.CANCELLED || status === CONSTANTS.DOCUMENT.STATUS.INIT) &&
        <Grid item>
          <Button
            variant='outlined'
            classes={{ root: classes.root }}
            aria-label='delete' onClick={() => handleDeleteFlow(true)}
          >
            {t('fileMenu:delete')}
          </Button>
        </Grid>}
      {status === CONSTANTS.DOCUMENT.STATUS.SEND_TO_SIGN &&
        <Grid item>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => handleCancelFlow(true)}
          >
            {t('fileMenu:cancel')}
          </Button>
        </Grid>}
    </>
  );
};

CardButton.propTypes = {
  document: PropTypes.object.isRequired,
  handleDeleteFlow: PropTypes.func.isRequired,
  handleCancelFlow: PropTypes.func.isRequired
};

export default CardButton;
